import { render, staticRenderFns } from "./Assistance.vue?vue&type=template&id=31377aec&"
import script from "./Assistance.vue?vue&type=script&lang=js&"
export * from "./Assistance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports